import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {postRecommendationUrl} from "../../constants/api/soft-user/endpoints";
import {jwtToJson} from "../../lib/jwt/jwtToJson";
import {toast} from "react-toastify";

export const useMutateRecommendation = ({userIsSoft}: { userIsSoft?: boolean }) => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  async function postData({data}: { data: any }) {
    return axios.post(postRecommendationUrl(userIsSoft), data, {timeout: 180000}
    ).then(response => response.data)
  }

  return useMutation({
    mutationKey: ['post-recommendation'],
    mutationFn: postData,
    retry: 1,
    onError: (error: any, variables) => {
      if (variables?.data?.course_id) {
        toast.error('Course id is not valid.');
      }
      if (error.response?.data) {
        return error.response.data;
      }
    },
    onSuccess: (data, variables) => {
      if (localStorage.getItem('refresh')) {
        if (jwtToJson(localStorage.getItem('refresh') ?? '')?.user_id) {
          queryClient.invalidateQueries({queryKey: ['portfolios-list', jwtToJson(localStorage.getItem('refresh') ?? '').user_id]})
        }
        if (variables?.data?.course_id) {
          queryClient.invalidateQueries({queryKey: ['courses']});
          toast.success('Course match score has been generated.')
        }
      }
    }
  });
}
